<template>
  <div class="content-block" style="margin-top: 0px">
    <footer class="footer">
      <p style="float: left;">Copyright © 2020-{{new Date().getFullYear()}} {{this.$appInfo.company_producer}}</p>
      <p style="float: right;">all trademarks are the property of their respective owners</p>
    </footer>
  </div>
</template>

<style lang="scss">
@import "../themes/generated/variables.base.scss";

.footer {
  display: block;
  color: rgba($base-text-color, alpha($base-text-color) * 0.7);
  border-top: 1px solid rgba(0, 0, 0, 0.1);
  padding-top: 10px;
  padding-bottom: 14px;
}
</style>
